import { type FC } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { appRoutes } from './appRoutes';

const App: FC = () => {
  const router = createBrowserRouter(appRoutes);

  return <RouterProvider router={router} />;
};

export default App;
